import BaseApiService from './BaseApiService'
import type { GlobalSearchResult } from '../types'

class SearchApiService extends BaseApiService {
  search(query: string, limitPerType = 8): Promise<GlobalSearchResult> {
    return this.post<GlobalSearchResult>('/v1/search', { query, limitPerType })
  }
}

export const searchApiService = new SearchApiService()
